/* eslint-disable no-useless-escape */
import { isMobile } from '@medflex/utils/mobile';
import Logger from '@medflex/utils/Logger';

export default () => ({
  config: {
    models: {
      system: {
        state: {
          visibilityState: 'visible',
        },
        reducers: {
          onPageVisibilityChanged(state, { visibilityState }) {
            return { ...state, visibilityState };
          },
        },
      },
    },
  },
  onStoreCreated() {
    const isMobileDevice = isMobile();
    if (isMobileDevice) {
      Logger.log(
        '[system::onStoreCreated] -> mobile device detected, add visibilitychange listener',
      );
      document.addEventListener('visibilitychange', () => {
        const { visibilityState } = document;
        this.dispatch.system.onPageVisibilityChanged({ visibilityState });
      });
    } else {
      Logger.log('[system::onStoreCreated] -> no mobile device omitting visibilitychange listener');
    }
  },
});
